import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { chapterAPI } from '../../utilities/api';
import { Chapter } from '../../utilities/interfaces/Chapter';

// represents the shape of the slice in state
interface ChapterState {
  chapter: Chapter | null;
  chapters: Chapter[];
  chaptersByTitleId: Record<number, Chapter[]>;
  error: string | null;
}

const initialState: ChapterState = {
  chapter: null,
  chapters: [],
  chaptersByTitleId: {},
  error: null,
};

const chapterSlice = createSlice({
  name: 'stateChapter',
  initialState,
  reducers: {
    // add new Chapter item
    addChapterItem(state, action: PayloadAction<Chapter>) {
      // its okay to do this because immer makes it immutable
      state.chapters.push(action.payload);
    },
    setChaptersForTitle(state, action: PayloadAction<{ titleId: number; chapters: Chapter[] }>) {
      state.chapters = action.payload.chapters;
      state.chaptersByTitleId[action.payload.titleId] = action.payload.chapters;
    },
    clearChapterItems(state) {
      state.chapters = [];
    },
    clearChapter(state) {
      state.chapter = null;
    },
  },
  extraReducers(builder) {
    builder.addCase(getChapterById.pending, (state, action: any) => {
      state.chapter = null;
    });
    builder.addCase(getChapterById.fulfilled, (state, action: any) => {
      state.chapter = action.payload;
    });
    builder.addCase(getChaptersByTitleId.fulfilled, (state, action: any) => {
      state.chapters = action.payload;
      state.chaptersByTitleId[action.meta.arg] = action.payload;
    });
    builder.addCase(updateChapter.fulfilled, (state, action: any) => {
      // find chapter in redux store and update
      var index = state.chapters.findIndex((x) => (x.id = action.payload.id));
      state.chapters[index] = action.payload;
    });
  },
});

// Async thunk to fetch data from api
// under extra reducers on fulfilled the redux store is updated
export const getChapterById = createAsyncThunk(
  'stateChapter/getChapterById',
  async (id: number) => {
    const response = await chapterAPI.getChapterById(id);
    return response;
  }
);

export const getChaptersByTitleId = createAsyncThunk(
  'stateChapter/getChaptersByTitleId',
  async (id: number) => {
    const response = await chapterAPI.getChaptersByTitleId(id);
    return response;
  }
);

export const updateChapter = createAsyncThunk(
  'stateChapter/saveChapter',
  async (chapter: Chapter) => {
    const response = await chapterAPI.updateChapter(chapter);
    return response;
  }
);

export const { addChapterItem, setChaptersForTitle, clearChapterItems, clearChapter } = chapterSlice.actions;
export default chapterSlice.reducer;
